import ChangeLog from "../constants/ChangeLog";
import {dashboardActionTypes} from "../constants/ActionTypes";

const initialState = {
  list: ChangeLog,
  filterType: null,
  filterTypeData: { },
  sort: {
    field: 'date',
    direction: 'desc'
  }
};

const changeLog = (state = initialState, action) => {
  switch (action.type) {
    case dashboardActionTypes.SET_CHANGELOG_FILTER:
      return {
        ...state,
        filterType: action.filterType,
        filterTypeData: action.data
      };
    case dashboardActionTypes.SET_CHANGELOG_SORT:
      return {
        ...state,
        sort: {
          field: action.field,
          direction: action.direction
        }
      };
    default:
      break;
  }

  return state;
};

export default changeLog;




// WEBPACK FOOTER //
// ./reducers/change-log.reducers.js